var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarning = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8125 25.8125L24.4375 4.29167C23.375 2.85417 21.75 2.04167 20 2.04167C18.1875 2.04167 16.5625 2.85417 15.5625 4.29167L2.1875 25.8125C0.937501 27.5 0.750001 29.6875 1.6875 31.5625C2.625 33.4375 4.5 34.625 6.625 34.625H33.375C35.5 34.625 37.375 33.4375 38.3125 31.5625C39.25 29.75 39.0625 27.5 37.8125 25.8125ZM35.8125 30.3125C35.3125 31.25 34.4375 31.8125 33.375 31.8125H6.625C5.5625 31.8125 4.6875 31.25 4.1875 30.3125C3.75 29.375 3.8125 28.3125 4.4375 27.5L17.8125 5.97917C18.3125 5.29167 19.125 4.85417 20 4.85417C20.875 4.85417 21.6875 5.22917 22.1875 5.97917L35.5625 27.5C36.1875 28.3125 36.25 29.375 35.8125 30.3125Z",
    fill: "#083057"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 13.6667C19.2499 13.6667 18.5624 14.2917 18.5624 15.1042V21.9167C18.5624 22.6667 19.1874 23.3542 19.9999 23.3542C20.8124 23.3542 21.4374 22.7292 21.4374 21.9167V15.0417C21.4374 14.2917 20.7499 13.6667 19.9999 13.6667Z",
    fill: "#083057"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 25C19.2499 25 18.5624 25.625 18.5624 26.4375V26.75C18.5624 27.5 19.1874 28.1875 19.9999 28.1875C20.8124 28.1875 21.4374 27.5625 21.4374 26.75V26.375C21.4374 25.625 20.7499 25 19.9999 25Z",
    fill: "#111928"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/warning.787501530ad0a3ed7816440b43216e11.svg";